import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Table } from 'react-bootstrap';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { Loading } from '@rd-web-markets/shared/dist/util';
const RecentClaimGroups = _ref => {
  let {
    claimGroups,
    recentClaimGroupIds,
    accountType
  } = _ref;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const columns = [{
    text: ''
  }, {
    text: t('task_name')
  }, {
    text: t('projects')
  }, {
    text: t('in_progress')
  }, {
    text: t('costs_collected')
  }];
  if (!claimGroups) {
    return /*#__PURE__*/React.createElement(Loading, null);
  }
  const getCurrentTask = claimGroup => {
    const task = claimGroup.tasks.find(task => task.status === 'in_progress');
    return task ? t(task.category_title) : t('not_started');
  };
  const getLastCompletedTaskTitle = claimGroup => {
    const allTasks = claimGroup.tasks.flatMap(task => task.tasks);
    const completedTasks = allTasks.filter(task => task.completed);
    if (completedTasks.length === 0) return null;
    return completedTasks[completedTasks.length - 1].title;
  };
  const rows = [];
  recentClaimGroupIds && claimGroups.length > 0 && recentClaimGroupIds.forEach(id => {
    const claimGroup = claimGroups.find(claimGroup => String(claimGroup.id) === id);
    if (claimGroup) {
      rows.push({
        claimGroupData: [claimGroup.name, `${location.pathname}/companies/${claimGroup.company_id}/${claimGroup.id}/master`],
        activePhase: getCurrentTask(claimGroup),
        projects: claimGroup.projects_count,
        inProgress: claimGroup.in_progress_projects,
        costsCollected: claimGroup.cost_collected_projects,
        missionFrequency: claimGroup.current_prorata_revision_period,
        subtask: getLastCompletedTaskTitle(claimGroup)
      });
    }
  });
  const handleViewAllClaimGroups = () => {
    history.push(`${location.pathname}/all_claim_groups?page=1&query=`);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !recentClaimGroupIds ? /*#__PURE__*/React.createElement("p", {
    className: "text-center text-secondary"
  }, t('no_recent_claim_groups')) : /*#__PURE__*/React.createElement(Table, {
    className: "table borderless"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, columns.map((column, index) => {
    return /*#__PURE__*/React.createElement("th", {
      className: "text-center",
      key: index
    }, column.text);
  }))), /*#__PURE__*/React.createElement("tbody", null, rows.map((row, index) => {
    return /*#__PURE__*/React.createElement("tr", {
      key: index
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
      to: row.claimGroupData[1]
    }, row.claimGroupData[0])), /*#__PURE__*/React.createElement("td", {
      className: "text-center"
    }, row.activePhase), /*#__PURE__*/React.createElement("td", {
      className: "text-center"
    }, row.projects), /*#__PURE__*/React.createElement("td", {
      className: "text-center"
    }, row.inProgress), /*#__PURE__*/React.createElement("td", {
      className: "text-center"
    }, row.costsCollected));
  }))), /*#__PURE__*/React.createElement("hr", null), accountType === 'admin' && /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleViewAllClaimGroups
  }, t('view_all_claim_groups')));
};
export default RecentClaimGroups;